import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import { Twofish } from 'ng-twofish';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { ResponseLogin } from '../../interface/responseLogin.interface';
import { AccountResponse } from '../../interface/account.interface';
import { DinamicoService } from '../../../service/dinamico.service';
import { ConsultaUsuariosRequest, ConsultaUsuariosResponse } from '../../interface/consulta-usuarios.interface';
import { ActualizarUsuarioRequest, ActualizarUsuarioResponse } from '../../interface/actualizar-usuario.interface';

export interface User {
  username: string;
  name: string;
  lastName: string;
  email: string;
  id: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private user: User | null = null;
  env = environment;
  key: string = '03E1E1AAA5BCA19FBA8C42058B4ABF28';
  constructor(private http: HttpClient, private dinamicoService: DinamicoService) {}
  login(username: string, password: string):Observable<ResponseLogin> {
    const body = {
      GamWSLoginInSDT: {
        
        Login: Twofish.encrypt64(username, this.key),
        Password: Twofish.encrypt64(password, this.key),
        CustomParameters: {
          Items: [
            {
              Id: Twofish.encrypt64('Pais', this.key),
              Token: '',
              Value: Twofish.encrypt64(this.dinamicoService.getPrefijo(), this.key),
            },
            {
              Id: 'App',
              Token: '',
              Value: 'Portal Concesionario Unificado '+this.dinamicoService.getPrefijo(),
            },
            {
              Id: 'Version',
              Token: '',
              Value: '1',
            },
          ],
        },
      },
    };
    return this.http.post<ResponseLogin>(this.env.login, body, {headers: { 'Ocp-Apim-Subscription-Key': this.env.api.login }})
    
  }
  
  logOut(){
  const keys = Object.keys(localStorage);
  
  keys.forEach(key => {
      localStorage.removeItem(key);
  });
  }
  cuentas():Observable<AccountResponse> {
    const usuario = localStorage.getItem("usuario");
    return this.http.get<any>(`${this.env.cuentas}${usuario}`, {headers: { 'Ocp-Apim-Subscription-Key': this.env.api.login }})
  }
  getUser(): User | null {
    return this.user;
  }

  getUsername(): string | null {
    return this.user ? this.user.username : null;
  }

  actualizarEstadoCuenta(datos: {
    numeroCuenta: string;
    finValidez: Date;
    rolPlataformasMoviles: string;
  }): Observable<any> {
    const url = `${this.env.cuentas}actualizarEstadoCuenta`;
    return this.http.post(url, {
      numeroCuenta: datos.numeroCuenta,
      finValidez: datos.finValidez.toISOString(),
      rolPlataformasMoviles: datos.rolPlataformasMoviles
    });
  }

  actualizarDatosCuenta(datosCuenta: any): Observable<any> {
    const url = `${this.env.cuentas}actualizarDatosCuenta`;
    return this.http.post(url, datosCuenta);
  }

  actualizarDatosUsuarioSAP(datos: {
    numeroCuenta: string;
    nif: string;
    nombresCuenta: string;
    apellidosCuenta: string;
    areaNegocios: string;
    cargo: string;
    departamento: string;
    telefonoFijo: string;
    telefonoMovil: string;
    mail: string;
    rolPlataformasMoviles: string;
    inicioValidez: Date;
    finValidez: Date;
  }): Observable<any> {
    const url = `${this.env.cuentas}actualizarDatosUsuarioSAP`;
    return this.http.post(url, {
      numeroCuenta: datos.numeroCuenta,
      nif: datos.nif,
      nombresCuenta: datos.nombresCuenta,
      apellidosCuenta: datos.apellidosCuenta,
      areaNegocios: datos.areaNegocios,
      cargo: datos.cargo,
      departamento: datos.departamento,
      telefonoFijo: datos.telefonoFijo,
      telefonoMovil: datos.telefonoMovil,
      mail: datos.mail,
      rolPlataformasMoviles: datos.rolPlataformasMoviles,
      inicioValidez: datos.inicioValidez.toISOString(),
      finValidez: datos.finValidez.toISOString(),
      tipoCuenta: 'CL',
      sapParams: {
        appServer: this.env.sap.appServer,
        clientNumber: this.env.sap.clientNumber,
        routerString: this.env.sap.routerString,
        systemId: this.env.sap.systemId,
        instanceNumber: this.env.sap.instanceNumber,
        sessionName: this.env.sap.sessionName,
        userName: this.env.sap.userName,
        password: this.env.sap.password
      }
    });
  }

  agregarContactoSAP(datos: {
    numeroCuenta: string;
    nif: string;
    nombresCuenta: string;
    apellidosCuenta: string;
    areaNegocios: string;
    cargo: string;
    departamento: string;
    telefonoFijo: string;
    telefonoMovil: string;
    mail: string;
    rolPlataformasMoviles: string;
    inicioValidez: Date;
    finValidez: Date;
  }): Observable<any> {
    const url = `${this.env.cuentas}agregarContactoSAP`;
    return this.http.post(url, {
      numeroCuenta: datos.numeroCuenta,
      nif: datos.nif,
      nombresCuenta: datos.nombresCuenta,
      apellidosCuenta: datos.apellidosCuenta,
      areaNegocios: datos.areaNegocios,
      cargo: datos.cargo,
      departamento: datos.departamento,
      telefonoFijo: datos.telefonoFijo,
      telefonoMovil: datos.telefonoMovil,
      mail: datos.mail,
      rolPlataformasMoviles: datos.rolPlataformasMoviles,
      inicioValidez: datos.inicioValidez.toISOString(),
      finValidez: datos.finValidez.toISOString(),
      tipoCuenta: 'CL',
      sapParams: {
        appServer: this.env.sap.appServer,
        clientNumber: this.env.sap.clientNumber,
        routerString: this.env.sap.routerString,
        systemId: this.env.sap.systemId,
        instanceNumber: this.env.sap.instanceNumber,
        sessionName: this.env.sap.sessionName,
        userName: this.env.sap.userName,
        password: this.env.sap.password
      }
    });
  }

  consultaUsuarios(data: ConsultaUsuariosRequest): Observable<ConsultaUsuariosResponse> {
    const token = localStorage.getItem('token');
    const headers = {
      'Authorization': `Bearer ${token}`,
      'Ocp-Apim-Subscription-Key': this.env.subscriptionKeyConsultaUsuarios
    };

    

    return this.http.post<ConsultaUsuariosResponse>(this.env.WS_CONSULTA_USUARIOS, data, { headers }).pipe(
      // Log no intrusivo de respuesta
      (source) => new Observable<ConsultaUsuariosResponse>((subscriber) => {
        source.subscribe({
          next: (resp) => subscriber.next(resp),
          error: (err) => subscriber.error(err),
          complete: () => subscriber.complete()
        });
      })
    );
  }

  /**
   * Actualiza la información de un usuario en GAM
   * @param data Datos del usuario a actualizar
   * @returns Observable con la respuesta de la actualización
   */
  actualizarUsuario(data: ActualizarUsuarioRequest): Observable<ActualizarUsuarioResponse> {
    const headers = {
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': this.env.subscriptionKeyConsultaUsuarios
    };

    return this.http.post<ActualizarUsuarioResponse>(this.env.WS_ACTUALIZAR_USUARIO, data, { headers });
  }
}
